import { useAppStateAssetGoalsListStore } from '../../../../common/store/AppStateStore.zustand';
import React, { useState } from 'react';
import { AssetReport } from '../../../assetReport/type/AssetReport.type';
import { numberWithCommas } from '../../../../common/util/NumberUtils';
import { useAssetGoalsAPI } from '../../api/AssetGoals.api';
import AddAssetGoalsModal, { AddAssetGoalsModalData } from './AddAssetGoalsModal';
import EditAssetGoalsModal, { EditAssetGoalsModalData } from './EditAssetGoalsModal';
import { AssetGoals } from '../../type/AssetGoals.type';

export interface ManageAssetGoalsModalData {
  isOpen: boolean;
  onClose: () => void;
}

const ManageAssetGoalsModal = ({ isOpen, onClose }: ManageAssetGoalsModalData) => {
  const { getAssetGoalsList, deleteAssetGoals } = useAssetGoalsAPI();
  const { assetGoalsList, setAssetGoalsList } = useAppStateAssetGoalsListStore();
  const [addAssetGoalsModalData, setAddAssetGoalsModalData] = useState<AddAssetGoalsModalData>();
  const [editAssetGoalsModalData, setEditAssetGoalsModalData] = useState<EditAssetGoalsModalData>();

  const handleCloseClick = () => {
    onClose();
  };

  const handleAddClick = () => {
    setAddAssetGoalsModalData({
      isOpen: true,
      onClose: () => setAddAssetGoalsModalData(undefined),
    });
  };

  const handleDeleteClick = async (assetGoalsId: string) => {
    await deleteAssetGoals(assetGoalsId);
    const { data } = await getAssetGoalsList();
    setAssetGoalsList(data);
  };

  const handleEditClick = async (assetGoals: AssetGoals) => {
    setEditAssetGoalsModalData({
      isOpen: true,
      assetGoals: assetGoals,
      onClose: () => setEditAssetGoalsModalData(undefined),
    });
  };

  return isOpen ? (
    <div className="fixed h-screen inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[80vh] overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-800">목표 관리</h2>
            <button onClick={() => handleCloseClick()} className="text-gray-400 hover:text-gray-600">
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(80vh - 140px)' }}>
          <div className="mb-6 flex justify-between items-center">
            <p className="text-gray-600">총 {assetGoalsList.length}개의 목표가 등록되어 있습니다.</p>
            <button
              onClick={() => handleAddClick()}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm flex items-center !rounded-button"
            >
              <i className="fas fa-plus mr-2"></i> 목표 추가하기
            </button>
          </div>
          <div className="bg-gray-50 rounded-lg">
            {assetGoalsList.map((assetGoals) => (
              <div key={assetGoals.id} className="p-4 border-b border-gray-200 last:border-b-0 hover:bg-gray-100">
                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-indigo-50 rounded-full flex items-center justify-center text-purple-500 mr-3">
                      <i className="fas fa-bullseye text-indigo-300"></i>
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-800">{assetGoals.name}</h3>
                      <div className="flex items-center space-x-4 mt-1">
                        <p className="text-sm text-gray-500">목표 달성일: {assetGoals.endYearMonth}</p>
                        <p className="text-sm text-gray-500">목표 금액: {numberWithCommas(assetGoals.endAmount)} 원</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      className="text-gray-400 hover:text-blue-500 p-2"
                      onClick={() => handleEditClick(assetGoals)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      onClick={() => handleDeleteClick(assetGoals.id)}
                      className="text-gray-400 hover:text-red-500 p-2"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-6 border-t border-gray-200 bg-gray-50">
          <div className="flex justify-end">
            <button
              onClick={() => handleCloseClick()}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-md text-sm !rounded-button"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
      {addAssetGoalsModalData && <AddAssetGoalsModal {...addAssetGoalsModalData} />}
      {editAssetGoalsModalData && <EditAssetGoalsModal {...editAssetGoalsModalData} />}
    </div>
  ) : (
    <></>
  );
};

export default ManageAssetGoalsModal;
